import { Button } from '@citrite/web-ui-component';
import styled from '@emotion/styled';

export const StyledViewButton = styled(Button.TextPrimary)`
	padding-right: 40px;
`;
